import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgVerificationSystemErrorModal',
})
export default class CmgVerificationSystemErrorModal extends Vue {
  
  get visible(): boolean {
    return this.$appStore.state.ui.modals.verificationSystemErrorModal.visible;
  }
  
  get args() {
    return this.$appStore.state.ui.modals.verificationSystemErrorModal.args;
  }
  
  get closeButtonImageUrl(): string {
    return this.$appStore.state.cms.images.buttons.xDarkBrown.default;
  }
  
  get sadAvocadoImgUrl(): string {
    return this.$appStore.state.cms.images.sadAvocado.default;
  }

  get retryIconUrl(): string {
    return this.$appStore.state.cms.images.icons.refreshGold.default;
  }

  get ctaText(): string {
    return this.args?.requiresSignOutOnFailure ? 'Continue As Guest' : 'Okay';
  }

  async leave() {
    await this.args?.onLeave();
    this.$services.ui.setModalVisibility('verificationSystemErrorModal', false);
    Vue.nextTick(() => {
      setTimeout(() => {
        this.$services.ui.focusBack();
      }, 1000);
    });
  }
}
